import React from "react";
import { Table, Tooltip } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { get } from "lodash";
import { connect } from "react-redux";

import {
  fetchIssueSubCategories,
  getDistrictDepartmentByParentIds
} from "../../../actions/mis.action";
import {
  getLocalstorage,
  isValidArray,
  replaceCharacterWith,
  setLocalstorage
} from "../../../helper";
import { STATUS } from "../../../constant";
import NoDataFound from "../../../component/NoDataFound";
import AppliedFilters from "../AppliedFilterDisplay";
import { OverlayTrigger } from "react-bootstrap";
import { fetchFlatFileReport } from "../../../actions/mis.action";
class FlatFileReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersAfterDeletion: getLocalstorage("filters")
    };
  }
  deleteFilter = (filter, index) => {
    let appliedFilters = getLocalstorage("filters");
    appliedFilters.splice(index, 1);
    const newFilters = setLocalstorage("filters", appliedFilters);
    this.setState({ filtersAfterDeletion: newFilters }, this.onDeletingFilters);
  };

  onDeletingFilters = () => {
    const { fetchFlatFileReport, onClearFilter } = this.props;
    const newRemainingFilters = getLocalstorage("filters");
    const results = {};

    newRemainingFilters.forEach(({ value, optionName }) => {
      if (
        optionName === "implementationMode" ||
        optionName === "projectClassification" ||
        optionName === "projectStatus" ||
        optionName === "issueStatus"
      ) {
        results[optionName] = results[optionName] || [];
        if (!results[optionName].includes(value)) {
          results[optionName].push(value);
        }
      } else if (
        optionName === "createdDate" ||
        optionName === "issueCreatedDate"
      ) {
        results[optionName] = value;
      } else if (optionName === "projectCost") {
        results[optionName] = [value];
      } else {
        results[optionName] = results[optionName] || [];
        const numValue = parseInt(value);
        if (!results[optionName].includes(numValue)) {
          results[optionName].push(numValue);
        }
      }
    });

    fetchFlatFileReport(results);
    onClearFilter(true);
  };

  removeAllFilters = () => {
    const { fetchFlatFileReport } = this.props;
    let appliedFilters = setLocalstorage("filters", null);
    fetchFlatFileReport(appliedFilters);
  };

  render() {
    const { misData, misFlatFileStatus } = this.props;
    const { filtersAfterDeletion } = this.state;
    return (
      <React.Fragment>
        <div className="mis-list">
          <AppliedFilters
            deleteFilter={this.deleteFilter}
            filters={getLocalstorage("filters") || []}
          />
          {getLocalstorage("filters") !== null &&
            getLocalstorage("filters").length >= 2 && (
              <div
                className="clear-all-filters"
                onClick={this.removeAllFilters}
              >
                Clear All
              </div>
            )}
        </div>
        <Table striped size="sm" className="mis-project-list table-striped">
          <thead>
            <tr>
              <th className="issue-id-column">Issue ID</th>
              <th className="issue-title-column">Issue Title</th>
              <th className="issue-group-column">Recipient Group</th>
              <th className="issue-status-column">Issue Status</th>
              <th className="issue-project-id-column">Project ID</th>
              <th className="issue-project-column">Project Name</th>
            </tr>
          </thead>
          <tbody>
            {misFlatFileStatus === STATUS.LOADING ? (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            ) : isValidArray(get(misData, "data")) ? (
              get(misData, "data").map((data, index) => {
                const issueTitle = get(data, "issueTitle", "NA");
                const issueGroup = get(data, "issueGroup", "NA");
                const issueProjectName = get(data, "projectName", "NA");
                return (
                  <tr>
                    <td className="issue-id-column">
                      {get(data, "issueId", "NA")}
                    </td>
                    <td className="issue-title-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            placement="bottom-start"
                            className="mis-tooltip"
                          >
                            {issueTitle}
                          </Tooltip>
                        }
                      >
                        <div>{issueTitle}</div>
                      </OverlayTrigger>
                    </td>
                    <td className="issue-group-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            placement="bottom-start"
                            className="mis-tooltip"
                          >
                            {issueGroup}
                          </Tooltip>
                        }
                      >
                        <div>{issueGroup}</div>
                      </OverlayTrigger>
                    </td>
                    <td className="issue-status-column">
                      {replaceCharacterWith(
                        get(data, "issueStatus", "NA"),
                        "_",
                        " "
                      )}
                    </td>
                    <td className="issue-project-id-column">
                      {get(data, "projectId", "NA")}
                    </td>
                    <td className="issue-project-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            placement="bottom-start"
                            className="mis-tooltip"
                          >
                            {issueProjectName}
                          </Tooltip>
                        }
                      >
                        <div>{issueProjectName}</div>
                      </OverlayTrigger>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    misFlatFileStatus: state.misReducer.misFlatFileStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchIssueSubCategories: fetchIssueSubCategories,
      getDistrictDepartmentByParentIds,
      fetchFlatFileReport
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlatFileReport);
